import { Flex, LoadingSignIcon } from '@lokalise/louis';

import AiLogo from '@app/components/AiLogo';

import { IconContainer, LogoContainer, SyncButtonContainer, TextContainer } from '../styles';

type UninitializedStateButtonProps = {
    onClick: () => void;
    loading?: boolean;
};

export const UninitializedStateButton = ({ loading, onClick }: UninitializedStateButtonProps) => (
    <SyncButtonContainer onClick={onClick}>
        <Flex align="center" gap={2} wrap="nowrap">
            {loading ? (
                <IconContainer align="center" justify="center">
                    <LoadingSignIcon size="16px" ariaLabel="LoadingIcon" />
                </IconContainer>
            ) : (
                <LogoContainer>
                    <AiLogo />
                </LogoContainer>
            )}
            <TextContainer>Sync with Lokalise AI</TextContainer>
        </Flex>
    </SyncButtonContainer>
);

export default UninitializedStateButton;
